import Image from 'next/image';

function ImageLayout({ images, handleClick }: any) {

    let imageDisplay;
    if (images.length === 1) {
        // If there's only one image, display it alone
        imageDisplay = (
            <div className="hidden md:block w-full" style={{ height: "446px" }}>
                <Image loading="lazy"
                    src={images[0]}
                    alt={`Image 0`}
                    onClick={() => handleClick(0)}
                    className="w-full h-full object-cover"
                    style={{
                        borderRadius: "14px",
                        marginRight: "4px",
                    }}
                />
            </div>
        );
    } else if (images.length === 2) {
        // If there are two images, display them side by side
        imageDisplay = (
            <div className="hidden md:flex w-full" style={{ height: "446px" }}>
                <Image loading="lazy" src={images[0]} alt={`Image 0`}
                    onClick={() => handleClick(0)}
                    className="w-1/2 h-full object-cover"
                    style={{
                        borderRadius: "14px",
                        marginRight: "4px",
                    }} />
                <Image loading="lazy" src={images[1]} alt={`Image 1`}
                    onClick={() => handleClick(1)}
                    className="w-1/2 h-full object-cover"
                    style={{
                        borderRadius: "14px",
                        marginLeft: "4px",
                    }} />
            </div>
        );
    } else if (images.length == 3) {
        // If there are three images, display them as described
        imageDisplay = (
            <div className="hidden md:flex w-full" style={{ height: "446px", borderRadius: "14px" }}>
                <Image loading="lazy" src={images[0]} alt={`Image 0`}
                    onClick={() => handleClick(0)}
                    className="w-1/2 h-full object-cover"
                    style={{
                        borderRadius: "14px",
                        marginRight: "4px",
                    }} />

                <div className="overflow-hidden w-1/2 h-full flex flex-col" style={{ borderRadius: "14px", marginLeft: "4px" }}>
                    <Image loading="lazy" src={images[1]} alt={`Image 1`}
                        onClick={() => handleClick(1)}
                        className="w-full h-1/2 object-cover"
                        style={{
                            borderRadius: "14px",
                            marginBottom: "4px",
                        }} />
                    <Image loading="lazy" src={images[2]} alt={`Image 2`}
                        onClick={() => handleClick(2)}
                        className="w-full h-1/2 object-cover"
                        style={{
                            borderRadius: "14px",
                            marginTop: "4px"
                        }} />
                </div>
            </div>
        );
    } else if (images.length >= 4) {
        // if there are 4 images
        const additionalImagesCount = images.length - 4;
        imageDisplay = (<div className="overflow-hidden hidden md:flex w-full" style={{ height: "446px", borderRadius: "14px" }}>
            <Image loading="lazy" src={images[0]} alt={`Image 0`}
                onClick={() => handleClick(0)}
                className="w-1/2 h-100 object-cover"
                style={{
                    borderRadius: "14px",
                    marginRight: "4px",
                }} />
            <div className="overflow-hidden flex flex-col w-1/2 h-full" style={{ borderRadius: "14px", marginLeft: "4px" }}>
                <Image loading="lazy" src={images[1]} alt={`Image 1`}
                    onClick={() => handleClick(1)}
                    className="w-full h-1/2 object-cover"
                    style={{
                        borderRadius: "14px",
                        marginBottom: "4px",
                    }} />
                <div className="overflow-hidden flex flex-row w-full h-1/2" style={{ borderRadius: "14px", marginTop: "4px" }}>
                    <Image loading="lazy" src={images[2]} alt={`Image 2`}
                        onClick={() => handleClick(2)}
                        className="w-1/2 h-full object-cover"
                        style={{
                            borderRadius: "14px",
                            marginRight: "4px"
                        }} />
                    {additionalImagesCount == 0 ? <Image loading="lazy" src={images[3]} alt={`Image 3`}
                        onClick={() => handleClick(3)}
                        className="w-1/2 h-full object-cover"
                        style={{
                            borderRadius: "14px",
                            marginLeft: "4px"
                        }} /> :
                        <div onClick={() => handleClick(3)} className="relative bg-cover bg-center h-full w-1/2 rounded-[14px] ml-[4px]"
                            style={{ backgroundImage: `url('${images[3].src}')` }}>
                            <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black bg-opacity-50 rounded-[14px]">
                                <span className="text-white text-m md:text-2xl sm-text font-bold">
                                    +{additionalImagesCount} More
                                </span>
                            </div>
                        </div>}
                </div>
            </div>
        </div>)
    }

    return (
        <>
            {imageDisplay}
            <div className="md:hidden w-full relative" style={{ height: "252px" }}>
                <Image loading="lazy"
                    src={images[0]}
                    alt={`Image 0`}
                    onClick={() => handleClick(0)}
                    className="w-full h-full object-cover"
                    style={{
                        borderRadius: "14px",
                        marginRight: "4px",
                    }}
                />
                <button onClick={() => handleClick(0)} className="absolute top-4 right-4 bg-text-sm text-white bg-slate-700 font-medium py-2 px-4 rounded-[14px] shadow-md focus:outline-none border-none hover:bg-slate-700 focus:bg-slate-700 active:bg-slate-700">
                    See +{images.length - 1} Images
                </button>
            </div>
        </>
    )
}
export default ImageLayout;
